import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { StatusPill } from "./Home";
import { FolderCode, Trash2, PlusCircle, Clock } from "lucide-react";

export default function Projects() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/projects").then((r) => setProjects(r.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const del = async (e, id) => {
    e.stopPropagation();
    if (!window.confirm("Delete this project permanently?")) return;
    try { await api.delete(`/projects/${id}`); toast.success("Project deleted"); load(); }
    catch (e) { toast.error("Delete failed"); }
  };

  return (
    <div className="space-y-6" data-testid="projects-page">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-head font-bold">Projects</h1>
        <button data-testid="projects-new" onClick={() => navigate("/dashboard/new")}
          className="h-10 px-4 rounded-xl bg-gradient-to-r from-emerald-500 to-cyan-500 text-slate-950 font-semibold flex items-center gap-2">
          <PlusCircle className="h-4 w-4" /> New
        </button>
      </div>

      {loading ? (
        <div className="text-slate-500">Loading...</div>
      ) : projects.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-slate-800 p-16 text-center">
          <FolderCode className="h-8 w-8 text-slate-600 mx-auto mb-3" />
          <p className="text-slate-400">No projects yet.</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {projects.map((p) => (
            <div key={p.id} data-testid={`project-card-${p.id}`} onClick={() => navigate(`/workspace/${p.id}`)}
              className="group cursor-pointer rounded-2xl border border-slate-800 bg-slate-900/40 p-5 hover:border-emerald-500/40 transition-colors">
              <div className="flex items-center justify-between mb-2">
                <span className="font-head font-semibold truncate">{p.name}</span>
                <StatusPill status={p.status} />
              </div>
              <p className="text-sm text-slate-400 line-clamp-2 h-10">{p.description || "No description"}</p>
              <div className="flex items-center justify-between mt-3">
                <span className="flex items-center gap-1 text-xs text-slate-500"><Clock className="h-3 w-3" /> {p.file_count} files</span>
                <button data-testid={`delete-project-${p.id}`} onClick={(e) => del(e, p.id)}
                  className="text-slate-600 hover:text-rose-400 opacity-0 group-hover:opacity-100 transition-opacity"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
